import { useState } from 'react';
import { camelCase } from 'lodash';
import { ASSESSMENT_STATUSES } from 'components/Assessments/constants';
import { useDispatch, useSelector } from 'react-redux';
import { WARNING_DURATION } from '../../../../contexts/NotificationsProvider';
import { ALL_ROUTES } from '../../../../config/routes';
import { enqueueSnackbar, SNACKBAR_VARIANTS, navigateToRoute } from '../../../../redux_store';
import QhsTable from '../../../Shared/Table/Table';
import TableActions from './TableActions';
import RowActions from './RowActions';

const AssessmentsTable = ({
  modifiedAssessments,
  dataLoading,
  toggleConfirmResentDialog,
  reloadData,
  totalCount,
  setEnableClaimModalInfo,
  setAssessmentLinkForShareModal,
  onLoadMoreRows,
  sort,
  onSort,
  filter,
  onFilter,
  reloadAssessmentsList,
  columns,
  tableKey,
  aggregations,
  tableTitle,
  hideMenuActions,
  fetchError,
}) => {
  const {
    en: { titles, notifications },
  } = useSelector(state => state.i18n);
  const {
    metadata: { currentAccount },
    isDistributionSponsor,
  } = useSelector(state => state.user);
  const [isDataChangingRequesting, setIsDataChangingRequesting] = useState(false);
  const dispatch = useDispatch();

  const redirectToAssessmentReport = props => {
    const { uuid, accountUUID, patientUUID, surveyName, status } = props;
    const isItChildAccount = accountUUID !== currentAccount.uuid && isDistributionSponsor;
    dispatch(
      navigateToRoute({
        route: {
          path: (isItChildAccount ? ALL_ROUTES.assessment.reportDS : ALL_ROUTES.assessment.report)
            .path,
          params: {
            currentAccountUuid: currentAccount.uuid,
            accountUuid: isItChildAccount ? accountUUID : null,
            patientUuid: patientUUID,
            assessmentUuid: uuid,
            status: camelCase(status),
          },
          title: `${surveyName} ${titles.report}`,
        },
      })
    );
  };

  const handleRowClick = assessment => {
    const status = camelCase(assessment.status);
    if (
      status === ASSESSMENT_STATUSES.completed ||
      status === ASSESSMENT_STATUSES.inProgress ||
      status === ASSESSMENT_STATUSES.eTransfer ||
      status === ASSESSMENT_STATUSES.pendingReview ||
      status === ASSESSMENT_STATUSES.partialProcessed
    ) {
      redirectToAssessmentReport(assessment);
    } else {
      dispatch(
        enqueueSnackbar({
          message: notifications.assessmentMustBeCompleted,
          options: {
            variant: SNACKBAR_VARIANTS.warning,
            autoHideDuration: WARNING_DURATION,
          },
        })
      );
    }
  };

  return (
    <QhsTable
      columns={columns}
      data={modifiedAssessments || []}
      fetchNextPage={onLoadMoreRows}
      isFetching={isDataChangingRequesting || dataLoading}
      isLoading={dataLoading && !modifiedAssessments}
      totalRowCount={totalCount}
      sorting={sort}
      setSorting={onSort}
      filter={filter}
      setFilters={onFilter}
      tableKey={tableKey}
      onRowClick={handleRowClick}
      showRefreshTableButton
      reloadData={reloadAssessmentsList}
      tableTitle={tableTitle}
      fetchError={fetchError}
      menuActions={
        !hideMenuActions && (
          <TableActions
            totalCount={totalCount}
            tableSort={sort}
            tableFilter={filter}
            columns={columns}
            aggregations={aggregations}
          />
        )
      }
      renderRowActionMenuItems={({ row, setAnchorEl }) => (
        <RowActions
          row={row}
          setAnchorEl={setAnchorEl}
          toggleConfirmResentDialog={toggleConfirmResentDialog}
          reloadData={reloadData}
          setEnableClaimModalInfo={setEnableClaimModalInfo}
          setAssessmentLinkForShareModal={setAssessmentLinkForShareModal}
          setIsDataChangingRequesting={setIsDataChangingRequesting}
          dataLoading={dataLoading}
          modifiedAssessments={modifiedAssessments}
        />
      )}
    />
  );
};

export default AssessmentsTable;
